import Model from '@/lib/data/Model';
import SharedEntity from '@/data/SharedEntity';
import PolicyExtension from './PolicyExtension';
import PolicyType from './PolicyType';
import FileStorageItem from '../FileStorageItem';
import PolicyInsured from './PolicyInsured';
import ClaimInfo from './ClaimInfo';
import CollectionInfo from './CollectionInfo';
import PolicyFollowUp from './PolicyFollowUp';

class InsPolicy extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'customer_id',
        'client_name',
        'policy_type_id',
        'policy_year',
        'policy_no',
        'quoted_premium',
        'bound_premiium',
        'rate_change',
        'uw_note',
        'policy_inspection_date',
        'record_state',
        'period_start',
        'period_end',
        {
            name: 'policy_type',
            association: {
                type: 'one',
                model: PolicyType,
            },
        },
        {
            name: 'policy_extensions',
            association: {
                type: 'many',
                model: PolicyExtension,
                collectionConfig: {
                    url: '/policy/extensions/list',
                },
            },
        },
        {
            name: 'files',
            association: {
                type: 'many',
                model: FileStorageItem,
                collectionConfig: {
                    url: '/policy/files/list',
                },
            },
        },
        {
            name: 'insureds',
            association: {
                type: 'many',
                model: PolicyInsured,
                collectionConfig: {
                    url: '/policy/insureds/list',
                },
            },
        },
        {
            name: 'claim_infos',
            association: {
                type: 'many',
                model: ClaimInfo,
                collectionConfig: {
                    url: '/policy/claiminfo/list',
                },
            },
        },
        {
            name: 'collection_info',
            association: {
                type: 'one',
                model: CollectionInfo,
            },
        },
        {
            name: 'follow_ups',
            association: {
                type: 'many',
                model: PolicyFollowUp,
                collectionConfig: {
                    url: '/policy/followup/list',
                },
            },
        },
        // claim info icin
        {
            name: 'shared_entity_claim_info',
            association: {
                type: 'one',
                model: SharedEntity,
            },
        },
        // collection info icin
        {
            name: 'shared_entity_col_info',
            association: {
                type: 'one',
                model: SharedEntity,
            },
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'remove',
            method: 'DELETE',
            url: '/customer/policy/delete',
            params: ['id'],
        },
        {
            name: 'saveOrUpdate',
            method: 'POST',
            url: '/customer/policy/saveorupdate',
            associated: true,
        },
        {
            name: 'filelist',
            method: 'POST',
            url: '/policy/files/list',
            associated: true,
        },
        {
            name: 'getPoliciesByCustomerId',
            method: 'POST',
            url: '/customer/policy/listbycustomerid',
            params: ['customer_id'],
        },
        {
            name: 'getPolicyById',
            url: '/customer/policy/getById',
            params: ['policy_id'],
        },
    ];
}

export default InsPolicy;
